<template>
    <div class="wrapper">
        <emoji-picker @emoji="append" ref="emojiPicker">
            <button class="emoji-invoker" slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }"
                @click.stop="clickEvent">
                <q-icon size="md" name="insert_emoticon" class="js-emojipicker" />
            </button>
            <div slot="emoji-picker" slot-scope="{ emojis, insert }">
                <div class="emoji-picker" :style="{ bottom: 0, right: 0 }">
                    <!-- <div class="emoji-picker__search">
                        <input type="text" v-model="search">
                    </div> -->
                    <div>
                        <div v-for="(emojiGroup, category) in emojis" :key="category">
                            <h5>{{ category }}</h5>
                            <div class="emojis">
                                <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="insert(emoji)"
                                    :title="emojiName">{{ emoji }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </emoji-picker>
    </div>
</template>

<script>
    import { EmojiPicker } from 'vue-emoji-picker'
    export default {
        name: 'STEmojiPicker',
        components: {
            EmojiPicker
        },
        data() {
            return {
                input: '',
                search: '',
            }
        },
        mounted(){
        },
        methods: {
            append(emoji) {
                this.$emit('input', emoji)
                this.$refs.emojiPicker.hide()
            },
        },
    }
</script>

<style lang="css" scoped>
    /* Tailwind CSS-styled demo is available here: https://codepen.io/DCzajkowski/pen/Brxvzj */

    .wrapper {
        position: relative;
        display: inline-block;
        width: 40px;
        height: 40px;
    }

    .regular-input {
        padding: 0.5rem 1rem;
        border-radius: 3px;
        border: 1px solid #ccc;
        width: 20rem;
        height: 12rem;
        outline: none;
    }

    .regular-input:focus {
        box-shadow: 0 0 0 3px rgba(66, 153, 225, .5);
    }

    .emoji-invoker {
        position: absolute;
        top: 0.5rem;
        right: 0.5rem;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        cursor: pointer;
        transition: all 0.2s;
        padding: 0;
        background: transparent;
        border: 0;
    }

    .emoji-invoker:hover {
        transform: scale(1.1);
    }

    .emoji-invoker>svg {
        fill: #b1c6d0;
    }

    .emoji-picker {
        position: absolute;
        z-index: 1;
        font-family: Montserrat;
        border: 1px solid #ccc;
        width: auto;
        min-width: 300px;
        height: 20rem;
        overflow: auto;
        padding: 1rem;
        box-sizing: border-box;
        border-radius: 0.5rem;
        background: #fff;
        box-shadow: 1px 1px 8px #c7dbe6;
    }

    .emoji-picker__search {
        display: flex;
    }

    .emoji-picker__search>input {
        flex: 1;
        border-radius: 10rem;
        border: 1px solid #ccc;
        padding: 0.5rem 1rem;
        outline: none;
    }

    .emoji-picker h5 {
        margin-bottom: 0;
        color: #b1b1b1;
        text-transform: uppercase;
        font-size: 0.8rem;
        cursor: default;
    }

    .emoji-picker .emojis {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
    }

    .emoji-picker .emojis:after {
        content: "";
        flex: auto;
    }

    .emoji-picker .emojis span {
        padding: 0.2rem;
        cursor: pointer;
        border-radius: 5px;
    }

    .emoji-picker .emojis span:hover {
        background: #ececec;
        cursor: pointer;
    }
</style>